import { Permissions } from '../../../reducers/root.reducer';

export const accountsPermissions: Permissions = [
  'ViewAccountsCategories',
  'EditAccountsCategories',
  'ViewAccountsBills',
  'EditAccountsBills',
  'ViewAccountsCreditAccounts',
  'EditAccountsCreditAccounts',
  'ViewAccountsCreditBooks',
  'EditAccountsCreditBooks',
  'EditAccountsExpenses',
  'ViewAccountsExpenses',
  'EditAccountsTransactionAccounts',
  'ViewAccountsTransactionAccounts',
] as Permissions;
